<template>
    <div class="landing-page app-page">
        <div class="landing__header-img"></div>
        <div class="landing__header-img-overlay"></div>
        <section class="landing-section front-page-section">
            <div class="punch-line-tile">
                    <div class="punch-line-tile__moto custom-title-font">Sākam augt!</div>
            </div>
        </section>
        <section class="blog-section">
            <v-container>
                <v-progress-circular
                        v-show="loadingPosts"
                        class="blog-section__loading"
                        :size="70"
                        :width="7"
                        color="green"
                        indeterminate
                ></v-progress-circular>
                <v-layout v-show="!loadingPosts" row wrap justify-center class="caterers__grid-layout-fix">
                    <BlogCard
                            v-for="document in documents"
                            v-bind:key="document.id"
                            v-bind:document="document">
                    </BlogCard>
                </v-layout>
                <v-layout class="blog-section__more-news-btn" justify-center>
                    <v-btn outlined color="green" to="/zinas">Visas ziņas</v-btn>
                </v-layout>
            </v-container>
        </section>
        <section class="reasons-section front-page-section">
            <div class="front-page-section__content">
                <h1>Kādēļ izvēlēties augu valsts uzturu?</h1>
            </div>
            <div class="reasons-section__reason-wrapper">
                <div class="reason-item" v-for="reason in reasonsWhy" :key="reason.id" :data-background="reason.title">
                    <div class="reason-item__content">
                        <i v-bind:class="reason.icon"></i>
                        <h3>{{ reason.headline }}</h3>
                        <p class="reason-item__text">{{ reason.text }}</p>
                    </div>
                    <div class="reason-item__bg-layer"></div>
                </div>
            </div>
        </section>
        
    </div>
</template>

<script>
    import BlogCard from '../components/BlogCard';
    import firebase from 'firebase/app';
    import firebaseCfg from '../firebaseConfig';

    export default {
        name: "LandingPage",
        components: {
            BlogCard
        },
        data(){
            return {
                authorized: false,
                loadingPosts: true,
                documents: [],
                reasonsWhy:[
                    {
                        icon: "fa fa-heartbeat",
                        title: "HEALTH",
                        headline: "Veselība",
                        text: "Veselīga dzīvesveida būtiska sastāvdaļa ir sabalansēts uzturs. Pārdomāts augu valsts uzturs palīdz saglabāt veselu sirdi un asinsvadus, kontrolēt svaru un izvairīties no otrā tipa diabēta un citām slimībām."
                    },
                    {
                        icon: "fas fa-utensil-spoon",
                        title: "TASTE",
                        headline: "Garša",
                        text: "Izvēlēties dzīvniekiem un videi draudzīgu ēdienu vēl nekad nav bijis tik vienkārši. Veikalos parādās aizvien jauni produkti, ar kuriem var viegli aizstāt gaļu, olas un pienu, un cauru gadu varam iegādāties dažādus augļus un dārzeņus. Augu valsts uzturs ir ne tikai ilgtspējīgs, bet arī garšīgs un sātīgs."
                    },
                    {
                        icon: "fa fa-paw",
                        title: "ANIMALS",
                        headline: "Dzīvnieki",
                        text: "Dzīvnieki. Katru gadu industriālā lopkopība pakļauj miljardiem dzīvnieku sāpju pilnai un vienmuļai dzīvei. Tāpat kā mājas mīluļiem – kaķiem un suņiem – arī lauksaimniecībā izmantotajiem dzīvniekiem piemīt unikālas rakstura īpašības: tie jūt sāpes, uztraukumu un prieku. Izvēloties augu valsts uzturu, mēs varam samazināt dzīvnieku skaitu, kas nolemti dzīvei fermās."
                    },
                    {
                        icon: "fa fa-leaf",
                        title: "ENVIRONMENT",
                        headline: "Vide",
                        text: "Rūpnieciskā lopkopība rada nesamērīgi lielu piesārņojumu un patērē daudz resursu. Vides piesārņojuma un klimata pārmaiņu radītās sekas pasaule piedzīvo jau šobrīd. Vienkāršs veids, kā mazināt savu negatīvo ietekmi uz vidi, ir izvēlēties vairāk maltīšu, kas pagatavotas no augu valsts produktiem."
                    },
                ]
            }
        },
        methods: {
            getArticles: function(){
                const that = this;
                const articles = [];

                firebaseCfg.db.collection("posts").where("published", "==", true).orderBy("createDate", "desc").limit(3).get().then(function(querySnapshot){
                    querySnapshot.forEach(function(doc){
                        let document = doc.data();
                        document.articleHref = "/zinas/"+doc.id;
                        articles.push(document);
                        that.documents = articles;

                        that.loadingPosts = false;
                    })
                });
            },
        },
        mounted() {
            const that = this;

            firebase.auth().onAuthStateChanged(function(user) {
                if (user) {
                    that.authorized = true;
                } else {
                    that.authorized = false;
                }
            });

            that.getArticles();
        }
    }
</script>

<style scoped>
    .blog-section {
        margin: 80px 0 0;
    }
    .blog-section__more-news-btn { margin-top: 25px; }
    .blog-section__loading {
        display: flex;
        margin: 0 auto;
    }
    .caterers__grid-layout-fix {
        display: grid;
        grid-template-columns: repeat(auto-fit, 330px);
        grid-column-gap: 20px;
        grid-row-gap: 35px;
    }
    .blogtrip-section__cont{
        margin: 80px 0 0;
        max-width: 1080px;
        width: 100%;
    }

    .landing__header-img {
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        position: absolute;
        background: url('https://firebasestorage.googleapis.com/v0/b/augam-vegan.appspot.com/o/reasons_why%2Fgrowth.jpg?alt=media&token=25c7f7ea-f292-420a-8e8f-1bbde01b8ac8');
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        /*clip-path: polygon( 0 0, 100% 0, 100% calc(100% - 5vw), 0 100% );*/
        background-attachment: fixed;
        opacity: 1;
        height: 100vh;
    }
    .landing__header-img-overlay {
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        position: absolute;
        background-color: #000;
        opacity: 0.2;
        height: 100vh;
        /*clip-path: polygon( 0 0, 100% 0, 100% calc(100% - 5vw), 0 100% );*/
    }
    .punch-line-tile {
        min-height: inherit;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        height: 100vh;
    }
    .punch-line-tile__moto {
        line-height: 60px;
        font-size: 3em;
        margin: 10px 0 150px 0;
        font-weight: bold;
        text-align: center;
        text-shadow: 1px 2px 1px #000;
        position: relative;
    }
    .front-page-section{
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        font-size: 18px;
        color: #404040;
    }
    /* LANDING section */

    .landing-section{
        background-color: #fff;
        color: #fff;
        text-shadow: 1px 1px #404040;
    }
    /* REASONS section */

    .reasons-section{
    }
    .reasons-section .front-page-section__content {
        margin: 80px 35px 0;
        text-align: center;
    }
    .reasons-section__reason-wrapper{
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        margin-top: 35px;
    }
    .reason-item{
        color: #fff;
        flex: 1;
        text-align: center;
        position: relative;
        background-size: cover;
        background-repeat:no-repeat;
        transition: 0.5s;
        height: 650px;
    }
    .reason-item__content svg { font-size: 55px; }
    .reason-item__content h3 { margin: 25px 0 }
    .reason-item[data-background='HEALTH']{background-image: url('https://firebasestorage.googleapis.com/v0/b/augam-vegan.appspot.com/o/reasons_why%2Fhealth.jpg?alt=media&token=f5237361-7bb2-4d0a-92d2-b1efc12f2cda'); background-position: right; }
    .reason-item[data-background='TASTE']{background-image: url('https://firebasestorage.googleapis.com/v0/b/augam-vegan.appspot.com/o/reasons_why%2Ftaste.jpg?alt=media&token=3cf649ff-d2c4-4d86-8ff5-d1eabcfb3f97'); background-position: center; }
    .reason-item[data-background='ANIMALS']{background-image: url('https://firebasestorage.googleapis.com/v0/b/augam-vegan.appspot.com/o/reasons_why%2Fcow.jpg?alt=media&token=ead72e7d-ea5d-40db-a345-c996e453a695'); background-position: center; }
    .reason-item[data-background='ENVIRONMENT']{background-image: url('https://firebasestorage.googleapis.com/v0/b/augam-vegan.appspot.com/o/reasons_why%2Fenvironment.jpg?alt=media&token=1ba784c7-4da1-49a1-8310-4b6249b9927d'); background-position: center; }
    .reason-item__content{
        margin: 100px 55px 0 55px;
        z-index: 900;
        position: relative;
        display: inline-block;
    }
    .reason-item__text {
        overflow: hidden;
        font-size: 17px;
    }
    /*@media (min-width: 1000px){*/
        /*.reason-item:hover{*/
            /*flex: 1.5;*/
        /*}*/
        /*.reason-item__content::after{*/
            /*!*content: "...";*!*/
            /*position: relative;*/
        /*}*/
        /*.reason-item:hover .reason-item__content::after{visibility: hidden;}*/
        /*@keyframes reasonExpand {*/
            /*0% {opacity: 0;}*/
            /*100% {opacity: 1;}*/
        /*}*/
        /*.reason-item:hover .reason-item__content{*/
            /*animation: reasonExpand 1s;*/
        /*}*/
        /*.reason-item:hover .reason-item__text{*/
            /*max-height: 650px;*/
        /*}*/
    /*}*/
    .reason-item__bg-layer{
        background-color: rgba(55, 60, 60, 0.45);
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
    /*.reason-item:hover .reason-item__bg-layer{*/
        /*background-color: rgba(55, 60, 60, 0.69);*/
        /*transition: background .5s ease-out;*/
    /*}*/
    .reason-item .reason-item__bg-layer{
        background-color: rgba(55, 60, 60, 0.69);
    }
    @media (max-width: 1245px) {
        .reason-item{
            height: 650px;
        }
        .reason-item__content{
            max-width: 205px;
            margin: 100px 20px;
        }
    }
    @media (max-width: 1000px) {
        .reason-item{
            height: auto;
        }
        .reason-item__content{
            max-width: none;
            margin: 50px 20px;
        }
        .reasons-section__reason-wrapper{
            flex-direction: column;
        }
        .reason-item__text{
            max-height: none;
        }
    }
    @media (max-width: 600px) {
        .front-page-section{
            font-size: 18px;
        }
        .reason-item__text{
            font-size: 18px;
        }
        .reasons-section .front-page-section__content {
            margin: 120px 35px 0;
        }
        .landing__header-img {
            background-attachment: scroll;
        }
    }
</style>